/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the SubscriptionInfo interface.
 */
export function instanceOfSubscriptionInfo(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    return true;
}
export function SubscriptionInfoFromJSON(json) {
    return SubscriptionInfoFromJSONTyped(json, false);
}
export function SubscriptionInfoFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        ...json,
        'status': json['status'],
        'tier': json['tier'],
    };
}
export function SubscriptionInfoToJSON(json) {
    return SubscriptionInfoToJSONTyped(json, false);
}
export function SubscriptionInfoToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        ...value,
        'status': value['status'],
        'tier': value['tier'],
    };
}
